import { getMaintenanceBreakData } from "./MaintenanceBreak.Connector";

export { getMaintenanceBreakData };


// WEBPACK FOOTER //
// ./src/API/maintenance-break-resource/index.ts